import { useCallback, useEffect, useState } from 'react';
import { usePrevious } from 'react-use';
import { HighlightType } from '../types/node';
import events, { CANVAS_CLICK } from '../utils/canvas/events/events';
import { getNodesInPath } from '../utils/node/getNodesInPath/getNodesInPath';
export var HighlightMatch;
(function (HighlightMatch) {
    HighlightMatch["Node"] = "node";
    HighlightMatch["Connection"] = "connection";
    HighlightMatch["Both"] = "both";
})(HighlightMatch || (HighlightMatch = {}));
export const useHighlight = ({ relations, invalidNodes, }) => {
    const [highlight, setHighlight] = useState({
        nodes: {},
        type: HighlightType.NONE,
    });
    const setHighlightPath = useCallback(({ path, only, type = HighlightType.INFO, match = HighlightMatch.Both, overrides = {}, }) => {
        const connectionsInPath = only || getNodesInPath(path, relations, 'connections');
        const nodes = connectionsInPath.reduce((nodes, id, index) => {
            const existingNode = overrides[id];
            nodes[id] = Object.assign(Object.assign({ match }, existingNode), { index });
            return nodes;
        }, {});
        setHighlight({ nodes, type });
    }, [setHighlight, relations]);
    const prevInvalidNodes = usePrevious(invalidNodes);
    useEffect(() => {
        const [nodeId] = invalidNodes;
        const isPreviouslyNodesSelected = prevInvalidNodes && prevInvalidNodes.length > 0;
        if (invalidNodes.length === 0 && isPreviouslyNodesSelected) {
            setHighlight({ nodes: {}, type: HighlightType.NONE });
        }
        if (nodeId) {
            setHighlightPath({ path: [null, nodeId], type: HighlightType.ERROR });
        }
    }, [invalidNodes, prevInvalidNodes, relations, setHighlightPath]);
    useEffect(() => {
        const listener = () => {
            if (invalidNodes.length > 0) {
                return;
            }
            setHighlight({ nodes: {}, type: HighlightType.NONE });
        };
        events.subscribe(CANVAS_CLICK, listener);
        return () => events.unsubscribe(listener);
    }, [invalidNodes, setHighlight]);
    return [highlight, setHighlightPath];
};
